import React, { useState, useEffect } from 'react';
import EmailSuccessPopup from '../Popups/EmailSuccessPopup';
import EmailFailedPopup from '../Popups/EmailFailedPopup';

const ContactForm = () => {
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [subject, setSubject] = useState('Landing page');
  const [companyName, setCompanyName] = useState('');
  const [userMessage, setUserMessage] = useState('');
  const [submittingForm, setSubmittingForm] = useState(false);
  const [handleSuccessPopup, setHandleSuccessPopup] = useState(false);
  const [handleFailedPopup, setHandleFailedPopup] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmitContactForm = (e) => {
    e.preventDefault();

    const userNameData = userName;
    const userEmailData = userEmail;
    const subjectData = subject;
    const companyNameData = companyName;
    const userMessageData = userMessage;

    const formDatas = {
      userName: userNameData,
      userEmail: userEmailData,
      subject: subjectData,
      companyName: companyNameData,
      userMessage: userMessageData,
    };

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };

    setSubmittingForm(true);

    fetch(`${apiUrl}/send-email`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(formDatas),
    })
      .then((response) => {
        if (response.ok) {
          setUserName('');
          setUserEmail('');
          setSubject('');
          setCompanyName('');
          setSubject('');
          setUserMessage('');
          setSubmittingForm(false);
          setHandleSuccessPopup(true);
        } else {
          console.log('Error when sending email');
          setSubmittingForm(false);
          setHandleFailedPopup(true);
        }
      })
      .catch((error) => {
        console.log('Error when sending email : ', error);
        setSubmittingForm(false);
        setHandleFailedPopup(true);
      });
  };

  const handleClosePopups = (e) => {
    e.preventDefault();
    setHandleSuccessPopup(false);
    setHandleFailedPopup(false);
  };

  const handleFocusInput = (e) => {
    const parentElement = e.target.parentElement;
    parentElement.classList.add('focused');
  };

  const handleBlurInput = (e) => {
    const parentElement = e.target.parentElement;
    if (e.target.value === '') {
      parentElement.classList.remove('focused');
    }
  };

  document.querySelectorAll('input, textarea').forEach((input) => {
    const parentElement = input.parentElement;
    if (input.value !== '') {
      parentElement.classList.add('focused');
    }
  });
  return (
    <form onSubmit={handleSubmitContactForm} action="">
      <div className="form-content hidden name-input">
        <label htmlFor="name">Votre nom*</label>
        <input
          type="text"
          id="name"
          name="name"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          required
          onFocus={handleFocusInput}
          onBlur={handleBlurInput}
        />
      </div>
      <div className="form-content hidden email-input">
        <label htmlFor="email">Votre e-mail*</label>
        <input
          type="email"
          id="email"
          name="email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          required
          onFocus={handleFocusInput}
          onBlur={handleBlurInput}
        />
      </div>
      <div className="form-content hidden subject-input">
        <label id="subjectLabel" htmlFor="subject">
          Sujet*
        </label>
        <select
          name="subject"
          id="subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
        >
          <option value="Site-vitrine">Landing page</option>
          <option value="Site-e-commerce">Site vitrine</option>
          <option value="Autre">Autre</option>
        </select>
      </div>
      <div className="form-content hidden company-input">
        <label htmlFor="company">Nom d'entreprise</label>
        <input
          type="text"
          id="company"
          name="company"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          onFocus={handleFocusInput}
          onBlur={handleBlurInput}
        />
      </div>
      <div className="form-content hidden message-input">
        <label htmlFor="message">Message*</label>
        <textarea
          name="message"
          id="message"
          cols="30"
          rows="10"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          required
          onFocus={handleFocusInput}
          onBlur={handleBlurInput}
        ></textarea>
      </div>
      <p className="required-field hidden">*Champs requis</p>
      <div className="btn-container">
        <button className="btn-style hidden" type="submit">
          {submittingForm ? 'Envoi en cours' : "C'est parti !"}
        </button>
      </div>
      <div className="popups-container">
        {handleSuccessPopup ? (
          <EmailSuccessPopup handleClosePopups={handleClosePopups} />
        ) : (
          ''
        )}
        {handleFailedPopup ? (
          <EmailFailedPopup handleClosePopups={handleClosePopups} />
        ) : (
          ''
        )}
      </div>
    </form>
  );
};

export default ContactForm;
